import { __decorate } from "tslib";
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import FormMixin from '@/amui/mixins/formMixin';
let AmBizSelectField = class AmBizSelectField extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.visible = false;
    this.tabs = [];
    this.options = {};
    this.title = '';
    this.list = [];
    this.activeTab = 0;
  }
  created() {
    this.initData();
  }
  initData() {
    switch (this.selectType) {
      case 'dept':
        this.tabs = ['department'];
        this.title = this.lowcode.i18n.get('apaas_amui_deptfield_label', '选择部门');
        this.options = {
          department: {
            childrenIncluded: this.childrenIncluded == 0 ? false : true,
            count: this.count
          }
        };
        break;
      case 'position':
        this.tabs = ['position'];
        this.title = window.lowcode.i18n.get('apaas_amui_positionfield_label', '选择岗位');
        break;
      case 'teacher':
        this.tabs = [{
          label: ' ',
          name: ' '
        }, {
          label: '讲师',
          name: 'teacherTab'
        }];
        this.title = window.lowcode.i18n.get('apaas_amui_teacherfield_label', '选择讲师');
        this.activeTab = 1;
        break;
      case 'user':
        this.tabs = ['department', 'person', 'manage'];
        this.options = {
          department: {
            count: this.count
          },
          person: {
            count: this.count
          }
        };
        break;
      case 'userGroup':
        this.tabs = ['usergroup'];
        this.title = window.lowcode.i18n.get('apaas_amui_usergroupfield_label', '选择用户组');
        break;
      default:
        this.tabs = [];
        break;
    }
  }
  open() {
    this.list = JSON.parse(JSON.stringify(this.value));
    this.visible = true;
  }
  confirm() {
    const count = this.list.length;
    if (this.selectType == 'teacher') {
      if (this.singleMode && count <= 1 || !this.singleMode) {
        this.update();
      } else {
        this.$message.warning(`只能选1条`);
      }
    } else {
      if (this.multiple) {
        if (this.limit == 0 || this.limit >= count) {
          this.update();
        } else {
          this.$message.warning(`最多只能选${this.limit}条`);
        }
      } else {
        if (count <= 1) {
          this.update();
        } else {
          this.$message.warning('只能选1条');
        }
      }
    }
  }
  update() {
    // 数组数据更新响应式
    this.value.splice(0, this.value.length, ...this.list);
    this.$emit('change', this.value);
    this.visible = false;
  }
};
AmBizSelectField.componentName = 'AmBizSelectField';
__decorate([Prop({
  default: ''
})], AmBizSelectField.prototype, "selectType", void 0);
__decorate([Prop({
  default: () => []
})], AmBizSelectField.prototype, "value", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectField.prototype, "multiple", void 0);
__decorate([Prop({
  default: 0
})], AmBizSelectField.prototype, "childrenIncluded", void 0);
__decorate([Prop({
  default: 0
})], AmBizSelectField.prototype, "limit", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectField.prototype, "count", void 0);
__decorate([Prop({
  default: -1
})], AmBizSelectField.prototype, "type", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectField.prototype, "singleMode", void 0);
__decorate([Prop({
  default: true
})], AmBizSelectField.prototype, "prepared", void 0);
__decorate([Prop({
  default: ''
})], AmBizSelectField.prototype, "functionCode", void 0);
__decorate([Prop({
  default: ''
})], AmBizSelectField.prototype, "dataPermissionCode", void 0);
__decorate([Watch('selectType')], AmBizSelectField.prototype, "initData", null);
AmBizSelectField = __decorate([Component({
  name: 'AmBizSelectField'
})], AmBizSelectField);
export default AmBizSelectField;